'use client'
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import FullProjectItem from "@/components/Projects/FullProjectItem";
import FullProjectItemMobile from "@/components/Projects/FullProjectItemMobile";
import { Player } from "@lottiefiles/react-lottie-player";
import { PrismicRichText } from "@prismicio/react";

const FullProjectItemsTitle = ({ title, text }) => {
  return <div className="h-fit mb-6 lg:mb-[90px] col-span-full">
    <div className="h2-like mb-4">
      <PrismicRichText field={title} />
    </div>
    <div>
      <PrismicRichText field={text} />
    </div>
  </div>
}

/**
 * @typedef {import("@prismicio/client").Content.FullProjectSlice} FullProjectSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FullProjectSlice>} FullProjectProps
 * @param {FullProjectProps}
 */
const FullProject = ({ slice, context, index }) => {


  function getCols(slice) {
    let arr1 = []
    let arr2 = []
    let arr3 = []
    for (let i = 0; i < slice.primary.projects.length; i++) {

      if (i % 3 == 0) arr1.push(<FullProjectItem key={i} index={index} label={slice.primary.projects[i].cta_label} project={slice.primary.projects[i].project} crsl_index={i} show_br={i % 2 === 1} isSquare={slice.primary.projects[i].isSquare} />)
      if (i % 3 == 1) arr2.push(<FullProjectItem key={i} index={index} label={slice.primary.projects[i].cta_label} project={slice.primary.projects[i].project} crsl_index={i} show_br={i % 2 === 1} isSquare={slice.primary.projects[i].isSquare} />)
      if (i % 3 == 2) arr3.push(<FullProjectItem key={i} index={index} label={slice.primary.projects[i].cta_label} project={slice.primary.projects[i].project} crsl_index={i} show_br={i % 2 === 1} isSquare={slice.primary.projects[i].isSquare} />)
    }
    const col1 = <div className="flex flex-col w-1/3 mr-10"><FullProjectItemsTitle title={slice.primary.title} text={slice.primary.text} />{arr1}</div>;
    const col2 = <div className="flex flex-col w-1/3 mr-5 ml-5">{arr2}</div>;
    const col3 = <div className="flex flex-col w-1/3 ml-10">{arr3}</div>;
    return <div className="lg:flex hidden">{col1} {col2} {col3}</div>
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white relative ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="absolute w-screen h-full top-0">
        <div className="sticky top-0">
          <div id="full-projects" >
            <Player
              autoplay
              className="w-screen relative"
              loop={false}
              keepLastFrame
              src={context.isMobileViewer ? '/anim/coulure-full-projects-mobile.json' : '/anim/coulure-full-projects.json'}>
            </Player>
          </div>
        </div>
      </div>
      <div className="relative z-[10] pt-[87px] md:pt-[100px] pb-2  md:pb-28">
        <div className="max-w-[1400px] m-auto px-4 md:px-7 lg:px-10 ">
          <Breadcrumbs context={context} index={index} />
          {
            !context.isMobileViewer && getCols(slice)
          }
          <div className="lg:hidden flex flex-wrap">
            <FullProjectItemsTitle title={slice.primary.title} text={slice.primary.text} />
            {
              slice.primary.projects.map((project, i) => {
                const isLast = i === slice.primary.projects.length - 1;
                const isEven = slice.primary.projects.length % 2 === 0;
                const hasExtraPadding = isLast && isEven;
                return (
                  <FullProjectItemMobile
                    index={index}
                    label={project.cta_label}
                    key={i}
                    project={project.project}
                    i={i}
                    show_br={i % 2 === 1}
                    isSquare={project.isSquare}
                    isLast={hasExtraPadding}
                  />
                );
              })
            }
          </div>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section>
  );
};

export default FullProject;
